
import "./AddOfficeForm.css";
import Navbar from "../components/Navbar/Navbar";
import TopHeader from "../components/Navbar/TopHeader";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { apiCall } from "../api/apiCall";
import generateToastContainer from "../utils/ToastContainer";
import { toast } from "react-toastify";
import { useTranslation } from "../i18n/UseTranslation";

function AddOfficeForm() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const translations = t.addOffice;

  const [name, setName] = useState("");
  const [isPlatform] = useState(false);
  const [isSubmitting, setIsSubmitting] =
    useState(false);

  const replaceMessage = (
    message: string,
    value: string
  ) => message.replace("{message}", value);

  const handleSubmit = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();

    if (!name.trim()) {
      toast.error(translations.nameRequired);
      return;
    }

    try {
      setIsSubmitting(true);

      await apiCall("/companies", {
        method: "POST",
        body: JSON.stringify({
          name: name.trim(),
          is_platform: isPlatform,
        }),
      });

      toast.success(translations.createSuccess);
      navigate("/offices");
    } catch (error) {
      console.error("[AddOfficeForm] Error:", error);

      const message =
        error instanceof Error
          ? error.message
          : String(error);

      toast.error(
        replaceMessage(translations.createError, message)
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="add-office-page office-form-content">

      <Navbar />
      <TopHeader />

      <div className="add-office-wrapper">
        <form
          className="add-office-card"
          onSubmit={handleSubmit}
        >
          <h1 className="add-office-title">
            {translations.title}
          </h1>

          <label className="add-office-label">
            {translations.officeName}

            <input
              type="text"
              className="add-office-input"
              placeholder={translations.officeNamePlaceholder}
              value={name}
              onChange={(event) =>
                setName(event.target.value)
              }
            />
          </label>

          {/* <label className="add-office-label-checkbox">
            <input
              type="checkbox"
              checked={isPlatform}
              onChange={(event) =>
                setIsPlatform(event.target.checked)
              }
            />

            <span>{translations.isMainPlatform}</span>
          </label> */}

          <div className="add-office-actions-form">
            <button
              type="button"
              className="add-office-cancel"
              onClick={() => navigate("/offices")}
              disabled={isSubmitting}
            >
              {translations.cancel}
            </button>

            <button
              type="submit"
              className="add-office-submit"
              disabled={isSubmitting}
            >
              {isSubmitting
                ? translations.creating
                : translations.createOffice}
            </button>
          </div>
        </form>

        {generateToastContainer()}
      </div>
    </div>
  );
}

export default AddOfficeForm;
